import { Link } from "react-router-dom"

const ErrorPage = () => {
    return(
    <>
            <h1>Error</h1>
            <h2><Link to={'/'}>На головну</Link></h2>
    </>)
}

export default ErrorPage